import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { NotificationService } from 'src/app/services/notification.service';
import { isInputOnlyDigit } from 'src/app/utils/validator';
import {
	CreateExploitationRequest,
	ExploitationEnabled,
	ExploitationType,
	FeatureUpdateLots,
	FlagMouvement,
	GetExploitationResponse,
	OffreAbonnement,
} from '../../services/dtos';

type ValidationError = 'length' | 'format' | 'emptyField';

@Component({
	templateUrl: './exploitation-summary-page.component.html',
	providers: [NotificationService],
	styleUrls: ['./exploitation-summary-page.component.scss'],
})
export class ExploitationSummaryPageComponent implements OnInit {
	private readonly DEFAULT_CREATION_OPTION: CreateExploitationRequest = {
		mouvement: FlagMouvement.MOUVEMENT_DISABLED,
		numeroCheptel: '',
		paysCheptel: 'FR',
		offreAbonnement: OffreAbonnement.ESSENTIEL,
		featureUpdateLots: FeatureUpdateLots.DISABLED,
		type: ExploitationType.LIVE,
		enabled: ExploitationEnabled.ENABLED,
	};

	errorType: ValidationError | null = null;

	exploitations: GetExploitationResponse[];
	selectedExploitation: GetExploitationResponse;

	newCheptelDraft: CreateExploitationRequest;
	showCheptelNewDialog: boolean;

	constructor(
		private apiService: ApiService,
		private router: Router,
		private route: ActivatedRoute,
		private notificationService: NotificationService,
	) {}

	ngOnInit() {
		this.updateExploitations();
	}

	updateExploitations() {
		this.apiService.exploitation_getAdminExploitations().subscribe({
			next: (response) => {
				this.exploitations = response.exploitations;
			},
			error: () => {
				// L'erreur est déjà gérée par l'intercepteur HTTP
				// On initialise juste la liste pour éviter que l'UI reste bloquée
				this.exploitations = [];
			},
		});
	}

	hideCreationCheptelDialog() {
		this.showCheptelNewDialog = false;
	}

	openCreationCheptelDialog() {
		this.newCheptelDraft = this.DEFAULT_CREATION_OPTION;
		this.showCheptelNewDialog = true;
		this.errorType = null;
	}

	private validateDraft() {
		const hasNumeroCheptel = this.newCheptelDraft.numeroCheptel !== '';
		if (!hasNumeroCheptel) {
			this.errorType = 'emptyField';
			return false;
		}
		const isInputLength8 = this.newCheptelDraft.numeroCheptel.length === 8;
		if (!isInputLength8) {
			this.errorType = 'length';
			return false;
		}
		const isInputTypeDigit = isInputOnlyDigit(this.newCheptelDraft.numeroCheptel);
		if (!isInputTypeDigit) {
			this.errorType = 'format';
			return false;
		}
		return true;
	}

	addCheptel() {
		if (this.validateDraft()) {
			this.showCheptelNewDialog = false;
			this.apiService.exploitation_postExploitation(this.newCheptelDraft).subscribe(
				() => {
					this.notificationService.notifySuccess('Cheptel créé');
					this.updateExploitations();
				},
				(err) => {
					this.notificationService.notifyError(err.statusText);
				},
			);
		}
	}

	onSelection(exploitation: GetExploitationResponse) {
		this.router.navigateByUrl(`inventaire/exploitation/${exploitation.numeroCheptel}`);
	}

	hasProperty(propertyName: string): boolean {
		return this.newCheptelDraft && propertyName in this.newCheptelDraft;
	}
}
